import type { EnumUnion } from '@dresscode-frontend/utility-types';
import type { ProductionListItem, ProductionStatus, ReleaseLevel } from '@/features/stacktrace/productions/-query/type';

/**
 * プロダクト詳細 > プロダクションタブ のテーブル列 ID。
 *
 * 表示項目:
 *   バージョン / レベル / ステータス / 説明 / リリース予定日 / リリース日時
 *
 * プロダクション一覧（`/production`）と違い「プロダクト」列は持たない。
 * 対象プロダクトは画面（URL の `$id`）で固定されているため、全行同じ値になる。
 */
export const ProductProductionTableColumns = {
  RELEASE: 'RELEASE',
  RELEASE_LEVEL: 'RELEASE_LEVEL',
  STATUS: 'STATUS',
  DESCRIPTION: 'DESCRIPTION',
  PLANNED_RELEASE_DATE: 'PLANNED_RELEASE_DATE',
  RELEASED_AT: 'RELEASED_AT'
} as const;
export type ProductProductionTableColumns = EnumUnion<typeof ProductProductionTableColumns>;
type ProductProductionReleaseColumn = {
  productionId: string;
  name: string;
};
export type ProductProductionTableRowData = {
  [ProductProductionTableColumns.RELEASE]: ProductProductionReleaseColumn;
  [ProductProductionTableColumns.RELEASE_LEVEL]: ReleaseLevel | undefined;
  [ProductProductionTableColumns.STATUS]: ProductionStatus | undefined;
  [ProductProductionTableColumns.DESCRIPTION]: string | null;
  [ProductProductionTableColumns.PLANNED_RELEASE_DATE]: string | null;
  [ProductProductionTableColumns.RELEASED_AT]: string | null;
};
export const convertProductProductionItemToTableRow = (item: ProductionListItem): ProductProductionTableRowData => ({
  [ProductProductionTableColumns.RELEASE]: {
    productionId: item.id,
    name: item.releaseName
  },
  [ProductProductionTableColumns.RELEASE_LEVEL]: item.releaseLevel,
  [ProductProductionTableColumns.STATUS]: item.status,
  [ProductProductionTableColumns.DESCRIPTION]: item.description,
  [ProductProductionTableColumns.PLANNED_RELEASE_DATE]: item.plannedReleaseDate,
  [ProductProductionTableColumns.RELEASED_AT]: item.releasedAt
});